import { createSlice } from '@reduxjs/toolkit';
import client from 'api/apiClient';
import { notify } from 'components/Common/Toast';
import { RootState } from 'redux/store';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { AnnouncementGroup } from 'types/announcements';
import { ID } from 'types/common';
import { createQueryPayams, getDefaultCompanyId, sortByField } from 'utils/helpers';

interface typesOfAnnouncementGroups {
    records: AnnouncementGroup[];
    loading: boolean;
    error: string | null;
}
const initialState: typesOfAnnouncementGroups = {
    records: [],
    loading: false,
    error: null,
};
export const createAnnouncementGroup = createAsyncThunkWrapper<any, any>(
    'createAnnouncementGroup',
    async ({ formData, formImage }: { formImage: any; formData: any }) => {
        const params = createQueryPayams(formData);
        const response: any = await client.post(`/createAnnouncementGroup?${params}`, formImage, {
            'Content-Type': 'multipart/form-data',
        });
        if (response?.code === 200) {
            notify('Announcement group created successfully!', 'success');
        }
        return response;
    }
);

const normalizeListResponse = (groups: any) => {
    if (!Array.isArray(groups) || !groups?.length) return [];
    return groups.map(({ announcementGroup, totalParticipants }) => ({ ...announcementGroup, totalParticipants }));
};
export const fetchAnnouncementGroups = createAsyncThunkWrapper('fetchAnnouncementGroups', async (_, { getState }) => {
    const state = getState() as RootState;
    const companyId = getDefaultCompanyId(state);
    let response: any = await client.get('/getAnnouncementGroupList', { headers: { companyId } });
    if (response.code === 200) {
        response = normalizeListResponse(response.announcementGroupList);
    }
    return response;
});

export const duplicateGroupById = createAsyncThunkWrapper<any,ID>('announcementGroup/duplicateGroupById', async (id: ID) => {
    let response: any = await client.post(`/duplicateAnnouncementGroup/${id}`);
    if (response.code === 200) {
        notify('Group duplicated successfully', 'success');
    }
    return response;
});

export const deleteGroupById = createAsyncThunkWrapper<any, any>('announcementGroup/deleteGroupById', async (id: number, { dispatch }) => {
    const res: any = await client.delete(`/deleteAnnouncementGroup/${id}`);
    if (res?.code === 200) {
        notify('Group deleted successfully', 'success');
        dispatch(fetchAnnouncementGroups());
    }
    return res;
});

const announcementGroupSlice = createSlice({
    name: 'announcementGroups',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAnnouncementGroups.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchAnnouncementGroups.fulfilled, (state, action) => {
            state.loading = false;
            const { payload } = action;
            if (!payload) return;
            state.records = sortByField(payload, 'id', 'DESC') || [];
        });
        builder.addCase(fetchAnnouncementGroups.rejected, (state) => {
            state.loading = false;
        });
    },
});
export default announcementGroupSlice.reducer;
